module.exports = __webpack_public_path__ + "static/media/SW01-Type-A_Texture.f57179c9.png";